module.exports = {
    "baseUrl": "https://pay-api.iris-health.com",
    "systemName": "System Prod",
    "basePath": null
}